import { DocumentNode, QueryHookOptions } from '@apollo/client';

import { useApiLazyQuery } from './useApiLazyQuery.hooks';
import { useApiQuery } from './useApiQuery.hooks';

interface HookConfig<TData, TVariables> {
  query: DocumentNode;
  key: string;
  defaultOptions?: QueryHookOptions<TData, TVariables>;
  withLoader?: boolean;
  successMsg?: string;
  buttonLoader?: boolean;
}

interface HookParams<TData, TVariables> {
  options?: QueryHookOptions<TData, TVariables>;
  hideSuccessMsg?: boolean;
}

export const createApiHook = <TData, TVariables>(
  config: HookConfig<TData, TVariables>
) => {
  const useQueryHook = ({
    options,
    hideSuccessMsg
  }: HookParams<TData, TVariables> = {}) =>
    useApiQuery(config.query, config.key, options, {
      successMsg: hideSuccessMsg ? undefined : config.successMsg,
      withLoader: config.withLoader
    });

  const useLazyHook = ({
    options,
    hideSuccessMsg
  }: HookParams<TData, TVariables> = {}) =>
    useApiLazyQuery(config.query, config.key, options, {
      successMsg: hideSuccessMsg ? undefined : config.successMsg,
      withLoader: config.withLoader,
      buttonLoader: config.buttonLoader
    });

  return {
    useQuery: useQueryHook,
    useLazy: useLazyHook
  };
};